import { Prose } from "./Prose";
import { DeleteForm } from "./DeleteForm";
import { useT } from "../../i18n/LangContext";

const Page = ({ children, testid }) => (
  <section className="bg-white px-5 pb-20 pt-12 sm:px-8 lg:pt-16" data-testid={testid}>
    <div className="mx-auto max-w-3xl">{children}</div>
  </section>
);

export const LegalPage = ({ doc }) => {
  const t = useT();
  return (
    <Page testid={`${doc}-page`}>
      <Prose md={t.legal[doc].md} testid={`${doc}-content`} />
    </Page>
  );
};

export const DeletePage = () => {
  const t = useT();
  return (
    <Page testid="delete-account-page">
      <Prose md={t.legal.deletion.md} testid="deletion-content" />
      <DeleteForm />
    </Page>
  );
};
